import { Table } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import {
	QUES_CODE_PREFIX,
	formatBrsrNumericCellValue,
	renderQuestionAnswer,
	renderType1TableAnswerForCurrentYear,
	renderType3TableAnswerForCurrentYear
} from '../../../../core/utilities/BRSRUtils';
import './../Reporting.scss';

const BRSRPrinciple6 = ({
	t,
	page8,
	yearFilter
}) => {

	// Wrapper to maintain compatibility with existing calls
	const renderType1TableAnswerForCurrentYearWrapper = (qIndex, colNos) => {
		return renderType1TableAnswerForCurrentYear(page8, 8, qIndex, colNos);
	};

	const renderTableAnswerForCurrentYearWrapper = (qIndex, colNos) => {
		const block = page8.currentYear?.[QUES_CODE_PREFIX + qIndex];
		if (block?.keyValueType === 'TYPE_3_TABLE') {
			const type3 = renderType3TableAnswerForCurrentYear(page8, 9, qIndex, colNos);
			if (type3 != null) return type3;
		}
		return renderType1TableAnswerForCurrentYear(page8, 8, qIndex, colNos);
	};

	const renderP6Q1 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-1']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page8?.['previousYear']) {
			page8['previousYear'][QUES_CODE_PREFIX + 'P6-1']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>1. Details of total energy consumption (in Joules or multiples) and energy intensity, in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th>Parameter</th>
								<th className='FY_class white-nowrap'>FY {yearFilter}</th>
								<th className='white-nowrap'>FY {yearFilter - 1}</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colSpan={3} className='font-color'><strong>From renewable sources</strong></td>
							</tr>
							<tr>
								<td>Total electricity consumption (A)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-1a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-1a'] ?? ''}</td>
							</tr>
							<tr>
								<td>Total fuel consumption (B)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-1b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-1b'] ?? ''}</td>
							</tr>
							<tr>
								<td>Energy consumption through other sources (C)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-1c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-1c'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total energy consumed from renewable sources (A+B+C)</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-1d'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-1d'] ?? ''}</td>
							</tr>
							<tr>
								<td colSpan={3} className='font-color'><strong>From non-renewable sources</strong></td>
							</tr>
							<tr>
								<td>Total electricity consumption (D)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-1e'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-1e'] ?? ''}</td>
							</tr>
							<tr>
								<td>Total fuel consumption (E)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-1f'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-1f'] ?? ''}</td>
							</tr>
							<tr>
								<td>Energy consumption through other sources (F)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-1g'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-1g'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total energy consumed from non-renewable sources (D+E+F)</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-1h'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-1h'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total energy consumption (A+B+C+D+E+F)</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-1i'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-1i'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Energy intensity per rupee of turnover</strong> (Total energy consumption / Revenue from operations)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-1j'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-1j'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Energy intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP)</strong> (Total energy consumption / Revenue from operations adjusted for PPP)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-1k'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-1k'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Energy intensity in terms of physical output</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-1l'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-1l'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Energy intensity</strong> <i>(optional)</i> – the relevant metric may be selected by the entity</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-1m'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-1m'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
					<p className='italic'>Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</p>
				</div>
			</div>
		);
	};

	const renderP6Q2 = () => {
		const currentYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-2']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('2. Does the entity have any sites / facilities identified as designated consumers (DCs) under the Performance, Achieve and Trade (PAT) Scheme of the Government of India? (Y/N) If yes, disclose whether targets set under the PAT scheme have been achieved. In case targets have not been achieved, provide the remedial action taken, if any.', currentYearAnswer[QUES_CODE_PREFIX + 'P6-2a'] ?? '');
	};

	const renderP6Q3 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-3']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page8?.['previousYear']) {
			page8['previousYear'][QUES_CODE_PREFIX + 'P6-3']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>3. Provide details of the following disclosures related to water, in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm" className="m-0">
						<thead>
							<tr>
								<th>Parameter</th>
								<th className='FY_class white-nowrap'>FY ({yearFilter})</th>
								<th className='white-nowrap'>FY ({yearFilter - 1})</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colSpan={3} className='font-color'><strong>Water withdrawal by source (in kilolitres)</strong></td>
							</tr>
							<tr>
								<td>(i) Surface water</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-3a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-3a'] ?? ''}</td>
							</tr>
							<tr>
								<td>(ii) Groundwater</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-3b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-3b'] ?? ''}</td>
							</tr>
							<tr>
								<td>(iii) Third party water</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-3c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-3c'] ?? ''}</td>
							</tr>
							<tr>
								<td>(iv) Seawater / desalinated water</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-3d'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-3d'] ?? ''}</td>
							</tr>
							<tr>
								<td>(v) Others</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-3e'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-3e'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total volume of water withdrawal (in kilolitres) (i + ii + iii + iv + v)</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-3f'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-3f'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total volume of water consumption (in kilolitres)</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-3g'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-3g'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Water intensity per rupee of turnover</strong> (Total water consumption / Revenue from operations)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-3h'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-3h'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Water intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP)</strong> (Total water consumption / Revenue from operations adjusted for PPP)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-3i'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-3i'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Water intensity in terms of physical output</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-3j'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-3j'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Water intensity</strong> <i>(optional)</i> – the relevant metric may be selected by the entity</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-3k'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-3k'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
					<p className='italic'>Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</p>
				</div>
			</div>
		);
	};

	const renderP6Q4 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-4']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page8?.['previousYear']) {
			page8['previousYear'][QUES_CODE_PREFIX + 'P6-4']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>4. Provide the following details related to water discharged</b>
				<div className="mt-2">
					<Table bordered size="sm" className="m-0">
						<thead>
							<tr>
								<th>Parameter</th>
								<th className='FY_class white-nowrap'>FY ({yearFilter})</th>
								<th className='white-nowrap'>FY ({yearFilter - 1})</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colSpan={3} className='font-color'><strong>Water discharge by destination and level of treatment (in kilolitres)</strong></td>
							</tr>
							<tr>
								<td><div className="table_list01"><b>(i) To Surface water</b></div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4a'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01">- No treatment</div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4b'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01">- With treatment – please specify level of treatment</div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4c'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01"><b>(ii) To Groundwater</b></div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4d'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4d'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01">- No treatment</div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4e'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4e'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01">- With treatment – please specify level of treatment</div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4f'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4f'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01"><b>(iii) To Seawater</b></div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4g'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4g'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01">- No treatment</div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4h'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4h'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01">- With treatment – please specify level of treatment</div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4i'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4i'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01"><b>(iv) Sent to third-parties</b></div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4j'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4j'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01">- No treatment</div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4k'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4k'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01">- With treatment – please specify level of treatment</div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4l'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4l'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01"><b>(v) Others</b></div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4m'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4m'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01">- No treatment</div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4n'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4n'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01">- With treatment – please specify level of treatment</div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4o'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4o'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01"><strong>Total water discharged (in kilolitres)</strong></div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-4p'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-4p'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
					<p className='italic'>Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</p>
				</div>
			</div>
		);
	};

	const renderP6Q5 = () => {
		const currentYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-5']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('5. Has the entity implemented a mechanism for Zero Liquid Discharge? If yes, provide details of its coverage and implementation.', currentYearAnswer[QUES_CODE_PREFIX + 'P6-5a'] ?? '');
	};

	const renderP6Q6 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-6']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page8?.['previousYear']) {
			page8['previousYear'][QUES_CODE_PREFIX + 'P6-6']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>6. Please provide details of air emissions (other than GHG emissions) by the entity, in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm" className="m-0">
						<thead>
							<tr>
								<th>Parameter</th>
								<th className='FY_class white-nowrap'>Please specify unit</th>
								<th className='FY_class white-nowrap'>FY ({yearFilter})</th>
								<th className='white-nowrap'>FY ({yearFilter - 1})</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>NOx</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6-1a'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-6a'] ?? ''}</td>
							</tr>
							<tr>
								<td>SOx</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6-1b'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-6b'] ?? ''}</td>
							</tr>
							<tr>
								<td>Particulate matter (PM)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6-1c'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-6c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Persistent organic pollutants (POP)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6-1d'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6d'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-6d'] ?? ''}</td>
							</tr>
							<tr>
								<td>Volatile organic compounds (VOC)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6-1e'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6e'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-6e'] ?? ''}</td>
							</tr>
							<tr>
								<td>Hazardous air pollutants (HAP)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6-1f'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6f'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-6f'] ?? ''}</td>
							</tr>
							<tr>
								<td>Others – please specify</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6-1g'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-6g'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-6g'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
					<p className='italic'>Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</p>
				</div>
			</div>
		);
	};

	const renderP6Q7 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-7']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page8?.['previousYear']) {
			page8['previousYear'][QUES_CODE_PREFIX + 'P6-7']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>7. Provide details of greenhouse gas emissions (Scope 1 and Scope 2 emissions) & its intensity, in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm" className="m-0">
						<thead>
							<tr>
								<th>Parameter</th>
								<th>Unit</th>
								<th className='FY_class white-nowrap'>FY ({yearFilter})</th>
								<th className='white-nowrap'>FY ({yearFilter - 1})</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong>Total Scope 1 emissions</strong> (Break-up of the GHG into CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, if available)</td>
								<td>Metric tonnes of CO2 equivalent</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-7a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-7a'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total Scope 2 emissions</strong> (Break-up of the GHG into CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, if available)</td>
								<td>Metric tonnes of CO2 equivalent</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-7b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-7b'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total Scope 1 and Scope 2 emission intensity per rupee of turnover</strong> (Total Scope 1 and Scope 2 GHG emissions / Revenue from operations)</td>
								<td></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-7c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-7c'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total Scope 1 and Scope 2 emission intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP)</strong> (Total Scope 1 and Scope 2 GHG emissions / Revenue from operations adjusted for PPP)</td>
								<td></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-7d'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-7d'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total Scope 1 and Scope 2 emission intensity in terms of physical output</strong></td>
								<td></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-7e'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-7e'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total Scope 1 and Scope 2 emission intensity</strong> (optional) – the relevant metric may be selected by the entity</td>
								<td></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-7f'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-7f'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
					<p className='italic'>Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</p>
				</div>
			</div>
		);
	};

	const renderP6Q8 = () => {
		const currentYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-8']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('8. Does the entity have any project related to reducing Green House Gas emission? If Yes, then provide details.', currentYearAnswer[QUES_CODE_PREFIX + 'P6-8a'] ?? '');
	};

	const renderP6Q9 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-9']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page8?.['previousYear']) {
			page8['previousYear'][QUES_CODE_PREFIX + 'P6-9']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>9. Provide details related to waste management by the entity, in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm" className="m-0">
						<thead>
							<tr>
								<th>Parameter</th>
								<th className='FY_class white-nowrap'>FY ({yearFilter})</th>
								<th className='white-nowrap'>FY ({yearFilter - 1})</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colSpan={3} className="text-center font-color"><strong>Total Waste generated (in metric tonnes)</strong></td>
							</tr>
							<tr>
								<td>Plastic waste <strong><i>(A)</i></strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9a'] ?? ''}</td>
							</tr>
							<tr>
								<td>E-waste <strong><i>(B)</i></strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9b'] ?? ''}</td>
							</tr>
							<tr>
								<td>Bio-medical waste <strong><i>(C)</i></strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Construction and demolition waste <strong><i>(D)</i></strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9d'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9d'] ?? ''}</td>
							</tr>
							<tr>
								<td>Battery waste <strong><i>(E)</i></strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9e'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9e'] ?? ''}</td>
							</tr>
							<tr>
								<td>Radioactive waste <strong><i>(F)</i></strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9f'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9f'] ?? ''}</td>
							</tr>
							<tr>
								<td>Other Hazardous waste. Please specify, if any. <strong><i>(G)</i></strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9g'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9g'] ?? ''}</td>
							</tr>
							<tr>
								<td>Other Non-hazardous waste generated <strong><i>(H)</i></strong> <i>Please specify, if any</i> (Break-up by composition i.e. by materials relevant to the sector)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9h'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9h'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total (A+B+C+D+E+F+G+H)</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9i'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9i'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Waste intensity per rupee of turnover</strong> (Total waste generated / Revenue from operations)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9j'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9j'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Waste intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP)</strong> (Total waste generated / Revenue from operations adjusted for PPP)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9k'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9k'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Waste intensity in terms of physical output</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9l'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9l'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Waste intensity</strong> <i>(optional)</i> – the relevant metric may be selected by the entity</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9m'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9m'] ?? ''}</td>
							</tr>
							<tr>
								<td colSpan={3} className="text-center font-color"><strong>For each category of waste generated, total waste recovered through recycling, re-using or other recovery operations (in metric tonnes)</strong></td>
							</tr>
							<tr>
								<td colSpan={3} className='font-color'><strong>Category of waste</strong></td>
							</tr>
							<tr>
								<td><div className="table_list01"><b>(i) Recycled</b></div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9n'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9n'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01"><b>(ii) Re-used</b></div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9o'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9o'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01"><b>(iii) Other recovery operations</b></div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9p'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9p'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9q'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9q'] ?? ''}</td>
							</tr>
							<tr>
								<td colSpan={3} className="text-center font-color"><strong>For each category of waste generated, total waste disposed by nature of disposal method (in metric tonnes)</strong></td>
							</tr>
							<tr>
								<td colSpan={3} className='font-color'><strong>Category of waste</strong></td>
							</tr>
							<tr>
								<td><div className="table_list01"><b>(i) Incineration</b></div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9r'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9r'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01"><b>(ii) Landfilling</b></div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9s'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9s'] ?? ''}</td>
							</tr>
							<tr>
								<td><div className="table_list01"><b>(iii) Other disposal operations</b></div></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9t'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9t'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-9u'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-9u'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
					<p className="m-0 italic">Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</p>
				</div>
			</div>
		);
	};

	const renderP6Q10 = () => {
		const currentYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-10']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('10. Briefly describe the waste management practices adopted in your establishments. Describe the strategy adopted by your company to reduce usage of hazardous and toxic chemicals in your products and processes and the practices adopted to manage such wastes.', currentYearAnswer[QUES_CODE_PREFIX + 'P6-10a'] ?? '');
	};

	const renderP6Q11 = () => {
		return (
			<div className='brsr-list-item'>
				<b>11. If the entity has operations/offices in/around ecologically sensitive areas (such as national parks, wildlife sanctuaries, biosphere reserves, wetlands, biodiversity hotspots, forests, coastal regulation zones etc.) where environmental approvals / clearances are required, please specify details in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th className='white-space'>S. No.</th>
								<th>Location of operations/offices</th>
								<th>Type of operations</th>
								<th>Whether the conditions of environmental approval / clearance are being complied with? (Y/N) If no, the reasons thereof and corrective action taken, if any.</th>
							</tr>
						</thead>
						<tbody>
							{renderType1TableAnswerForCurrentYearWrapper('P6-11', ['', 'a', 'b', 'c'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP6Q12 = () => {
		return (
			<div className='brsr-list-item'>
				<b>12. Details of environmental impact assessments of projects undertaken by the entity based on applicable laws, in the current financial year:</b>
				<div className="mt-2 mb-2">
					<Table responsive bordered size="sm" className="m-0">
						<thead>
							<tr>
								<th>Name and brief details of project</th>
								<th>EIA Notification No.</th>
								<th>Date</th>
								<th>Whether conducted by independent external agency (Yes / No)</th>
								<th>Results communicated in public domain (Yes / No)</th>
								<th>Relevant Web link</th>
							</tr>
						</thead>
						<tbody>
							{renderType1TableAnswerForCurrentYearWrapper('P6-12', ['a', 'b', 'c', 'd', 'e', 'f'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP6Q13 = () => {
		return (
			<div className='brsr-list-item'>
				<b>13. Is the entity compliant with the applicable environmental law/ regulations/ guidelines in India; such as the Water (Prevention and Control of Pollution) Act, Air (Prevention and Control of Pollution) Act, Environment  protection  act  and  rules  hereunder  (Y/N).    If  not,  provide  details  of  all  such  non-compliances, in the following format:</b>
				<div className="mt-2 mb-2">
					<Table responsive bordered size="sm" className="m-0">
						<thead>
							<tr>
								<th>S. No.</th>
								<th>Specify the law / regulation / guidelines  which  was not complied with</th>
								<th>Provide details of the non-compliance</th>
								<th>Any fines / penalties / action taken by regulatory agenciessuch as pollution control boards or by courts</th>
								<th>Corrective action taken, if any</th>
							</tr>
						</thead>
						<tbody>
							{renderTableAnswerForCurrentYearWrapper('P6-13', ['', 'a', 'b', 'c', 'd'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP6LI1 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-LI1']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page8?.['previousYear']) {
			page8['previousYear'][QUES_CODE_PREFIX + 'P6-LI1']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>1. Water withdrawal, consumption and discharge in areas of water stress (in kilolitres)</b>
				<div>
					<b>For each facility / plant located in areas of water stress, provide the following information:</b>
					{renderQuestionAnswer('(i) Name of the area', currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-1'] ?? '')}
					{renderQuestionAnswer('(ii) Nature of operations', currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-2'] ?? '')}
					<div className='brsr-list-item'>
						<b>{'(iii) Water withdrawal, consumption and discharge in the following format:'}</b>
					</div>
					<div className="mt-2">
						<Table bordered size="sm" className="m-0">
							<thead>
								<tr>
									<th>Parameter</th>
									<th className='FY_class white-nowrap'>FY ({yearFilter})</th>
									<th className='white-nowrap'>FY ({yearFilter - 1})</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td colSpan={3} className='font-color'><strong>Water withdrawal by source (in kilolitres)</strong></td>
								</tr>
								<tr>
									<td><div className="table_list01"><b>(i) Surface water</b></div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3a'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3a'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01"><b>(ii) Groundwater</b></div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3b'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3b'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01"><b>(iii) Third party water</b></div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3c'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3c'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01"><b>(iv) Seawater / desalinated water</b></div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3d'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3d'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01"><b>(v) Others</b></div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3e'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3e'] ?? ''}</td>
								</tr>
								<tr>
									<td><strong>Total volume of water withdrawal (in kilolitres)</strong></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3f'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3f'] ?? ''}</td>
								</tr>
								<tr>
									<td><strong>Total volume of water consumption (in kilolitres)</strong></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3g'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3g'] ?? ''}</td>
								</tr>
								<tr>
									<td><strong>Water intensity per rupee of turnover</strong> <i>(Water consumed / turnover)</i></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3h'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3h'] ?? ''}</td>
								</tr>
								<tr>
									<td><strong>Water intensity</strong> <i>(optional)</i> – the relevant metric may be selected by the entity</td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3i'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3i'] ?? ''}</td>
								</tr>
								<tr>
									<td colSpan={3} className='font-color'><strong>Water discharge by destination and level of treatment (in kilolitres)</strong></td>
								</tr>
								<tr>
									<td><div className="table_list01"><b>(i) Into Surface water</b></div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3j'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3j'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01">- No treatment</div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3k'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3k'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01">- With treatment – please specify level of treatment</div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3l'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3l'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01"><b>(ii) Into Groundwater</b></div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3m'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3m'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01">- No treatment</div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3n'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3n'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01">- With treatment – please specify level of treatment</div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3o'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3o'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01"><b>(iii) Into Seawater</b></div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3p'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3p'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01">- No treatment</div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3q'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3q'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01">- With treatment – please specify level of treatment</div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3r'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3r'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01"><b>(iv) Sent to third-parties</b></div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3s'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3s'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01">- No treatment</div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3t'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3t'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01">- With treatment – please specify level of treatment</div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3u'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3u'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01"><b>(v) Other</b></div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3v'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3v'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01">- No treatment</div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3w'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3w'] ?? ''}</td>
								</tr>
								<tr>
									<td><div className="table_list01">- With treatment – please specify level of treatment</div></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3x'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3x'] ?? ''}</td>
								</tr>
								<tr>
									<td><strong>Total water discharged (in kilolitres)</strong></td>
									<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3y'] ?? ''}</td>
									<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI1-3y'] ?? ''}</td>
								</tr>
							</tbody>
						</Table>
						<p className='italic'>Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</p>
					</div>
				</div>
			</div>
		);
	};

	const renderP6LI2 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-LI2']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page8?.['previousYear']) {
			page8['previousYear'][QUES_CODE_PREFIX + 'P6-LI2']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>2. Please provide details of total Scope 3 emissions & its intensity, in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm" className="m-0">
						<thead>
							<tr>
								<th>Parameter</th>
								<th>Unit</th>
								<th className='FY_class white-nowrap'>FY ({yearFilter})</th>
								<th className='white-nowrap'>FY ({yearFilter - 1})</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong>Total Scope 3 emissions</strong> (Break-up of the GHG into CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, if available)</td>
								<td>Metric tonnes of CO2 equivalent</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI2a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI2a'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total Scope 3 emissions per rupee of turnover</strong></td>
								<td></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI2b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI2b'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total Scope 3 emission intensity</strong> (optional) – the relevant metric may be selected by the entity</td>
								<td></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI2c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P6-LI2c'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
					<p className='italic'>Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</p>
				</div>
			</div>
		);
	};

	const renderP6LI3 = () => {
		const currentYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-LI3']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('3. With respect to the ecologically sensitive areas reported at Question 11 of Essential Indicators above, provide details of significant direct & indirect impact of the entity on biodiversity in such areas along-with prevention and remediation activities.', currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI3a'] ?? '');
	};

	const renderP6LI4 = () => {
		const currentYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-LI4']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>4. If the entity has undertaken any specific initiatives or used innovative technology or solutions to improve resource efficiency, or reduce impact due to emissions / effluent discharge / waste generated, please provide details of the same as well as outcome of such initiatives, as per the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm" className="m-0">
						<thead>
							<tr>
								<th>Sr. No</th>
								<th>Initiative undertaken</th>
								<th>Details of the initiative <i>(Web-link, if any, may be provided along-with summary)</i></th>
								<th>Outcome of the initiative</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>1</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI4a'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI4b'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI4c'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
					<p className='italic'>Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.</p>
				</div>
			</div>
		);
	};

	const renderP6LI5 = () => {
		const currentYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-LI5']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('5. Does the entity have a business continuity and disaster management plan? Give details in 100 words/ web link.', currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI5a'] ?? '');
	};

	const renderP6LI6 = () => {
		const currentYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-LI6']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('6. Disclose any significant adverse impact to the environment, arising from the value chain of the entity. What mitigation or adaptation measures have been taken by the entity in this regard.', currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI6a'] ?? '');
	};

	const renderP6LI7 = () => {
		const currentYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-LI7']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('7. Percentage of value chain partners (by value of business done with such partners) that were assessed for environmental impacts.', currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI7a'] ?? '');
	};


	const renderP6LI8 = () => {
		const currentYearAnswer = {};
		if (page8?.['currentYear']) {
			page8['currentYear'][QUES_CODE_PREFIX + 'P6-LI8']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>8. How many Green Credits have been generated or procured:</b>
				<div className="mt-2">
					<Table bordered size="sm" className="m-0">
						<thead>
							<tr>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>By the listed entity</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI8a'] ?? ''}</td>
							</tr>
							<tr>
								<td>By the top ten (in terms of value of purchases and sales, respectively) value chain partners</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P6-LI8b'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>

				</div>
			</div>
		);
	};

	return (
		<section id="PRINCIPLE_6" className="Main_Section PRINCIPLE_6">
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 1">
					<div className="ETA_card_Section_head">
						<h5>PRINCIPLE 6: Businesses should respect and make efforts to protect and restore the environment</h5>
					</div>
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head">
								<b>Essential Indicators</b>
							</div>
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP6Q1()}
									{renderP6Q2()}
									{renderP6Q3()}
									{renderP6Q4()}
									{renderP6Q5()}
									{renderP6Q6()}
									{renderP6Q7()}
									{renderP6Q8()}
									{renderP6Q9()}
									{renderP6Q10()}
									{renderP6Q11()}
									{renderP6Q12()}
									{renderP6Q13()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 2">
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head mb-3">
								<b>Leadership Indicators</b>
							</div>
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP6LI1()}
									{renderP6LI2()}
									{renderP6LI3()}
									{renderP6LI4()}
									{renderP6LI5()}
									{renderP6LI6()}
									{renderP6LI7()}
									{renderP6LI8()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</section>
	);
};

export default withTranslation()(BRSRPrinciple6);
